import React from 'react';
import { Box } from '@mui/material';
import PasswordOnboardingDialog from './PasswordOnboardingDialog';
import {
  clearProvisionalLoginPassword,
  offerPasswordManagerSave,
  takeProvisionalLoginPassword,
} from '../utils/passwordManager';

export default function PasswordOnboardingGate({ refreshUser }) {
  const handleComplete = async (updatedUser, meta) => {
    const email = updatedUser?.email;
    let passwordToSave = null;
    if (meta?.action === 'set' && meta.password) {
      passwordToSave = meta.password;
    } else if (meta?.action === 'keep') {
      passwordToSave = takeProvisionalLoginPassword();
    } else {
      clearProvisionalLoginPassword();
    }

    if (email && passwordToSave) {
      await offerPasswordManagerSave({ email, password: passwordToSave });
    }

    await refreshUser();
  };

  return (
    <Box sx={{ minHeight: '100vh', bgcolor: 'background.default' }}>
      <PasswordOnboardingDialog open onComplete={handleComplete} />
    </Box>
  );
}
